import { useContext } from 'react';
import { CustomFormContext } from '../../components/customFormContextProvider';

const useDidCountryUpdate = () => {
  const customFormContext = useContext(CustomFormContext);
  let [selectedCountry, setSelectedCountry] = customFormContext?.selectedCountry ?? [];
  const setValues = (value) => {
    if (value && setSelectedCountry) {
      setSelectedCountry(value);
    }
  };
  return setValues;
};

export default useDidCountryUpdate;
